import { render, staticRenderFns } from "./RegisterComponent.vue?vue&type=template&id=689b2683&scoped=true"
import script from "./RegisterComponent.vue?vue&type=script&lang=js"
export * from "./RegisterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689b2683",
  null
  
)

export default component.exports